export const CHANNELS = {
    MAIN: "main_communication_channel"
}

export const ROUTES = {
    INIT: "init",
}

export const REPONSE_TYPE = {
    EVENT: "event",
    PACKAGE_STATUS: "packagesStatus",
    DELIVERIES_STATUS: "deliveriesStatus",
    CALLBACK: "callback"
}

export const STREAMS = {
    PACKAGE_STATUS: "packages/status/subscribe",
    PACAKGE_DELIVERY_STATUS: "packages/deliveries/status/subscribe",
}

export const PERMISSION = {
    INSTALL: "install"
}

export const PERMISSION_STATUS = {
    GRANTED: "granted"
}